import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'canvas-admin-button',
    templateUrl: './admin-button.component.html',
    styleUrls: ['./admin-button.component.scss'],
    standalone: false
})
export class AdminButtonComponent {

  @Output() clicked = new EventEmitter();
  @Input() routerLink: any | undefined = undefined;
  @Input() additionalClasses = '';
  @Input() isDisabled = false;

  onClick() {
    if (this.clicked) {
      this.clicked.emit({});
    }
  }

}
